import { ComponentCategory, ComponentType } from '../../types';

export default {
  name: ComponentType.Avatar,
  title: 'Avatar',
  category: ComponentCategory.General,
};
